import { render, staticRenderFns } from "./RepeatableItem.vue?vue&type=template&id=0c87aef9&"
import script from "./RepeatableItem.vue?vue&type=script&lang=ts&"
export * from "./RepeatableItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports